import apiClient from "../authentication/utils/core/axios";

/**
 * Gamification API service
 */
const GamificationAPI = {
  fetchPoints: async (userId) => {
    const response = await apiClient.get(`/gamification/points/${userId}`);
    if (response.status !== 200) {
      throw new Error('Failed to fetch user points');
    }
    return response.data;
  },

  addPoints: async (userId, pointsData) => {
    const { points, reason } = pointsData;
    const params = new URLSearchParams();
    params.append('points', points);
    if (reason) params.append('reason', reason);
    
    const response = await apiClient.post(`/gamification/points/${userId}?${params}`);
    if (response.status !== 200) {
      throw new Error('Failed to add points');
    }
    return response.data;
  },

  createBadge: async (badgeData) => {
    const { name, description, criteria } = badgeData;
    const params = new URLSearchParams();
    params.append('name', name);
    params.append('description', description);
    params.append('criteria', criteria);
    
    const response = await apiClient.post(`/gamification/badges?${params}`);
    if (response.status !== 200) {
      throw new Error('Failed to create badge');
    }
    return response.data;
  },

  assignBadge: async (assignmentData) => {
    const { userId, badgeId } = assignmentData;
    const params = new URLSearchParams();
    params.append('user_id', userId);
    params.append('badge_id', badgeId);
    
    const response = await apiClient.post(`/gamification/badges/assign?${params}`);
    if (response.status !== 200) {
      throw new Error('Failed to assign badge');
    }
    return response.data;
  },

  fetchUserBadges: async (userId) => {
    const response = await apiClient.get(`/gamification/badges/${userId}`);
    if (response.status !== 200) {
      throw new Error('Failed to fetch user badges');
    }
    return response.data;
  },

  fetchBadgeProgress: async (userId) => {
    const response = await apiClient.get(`/gamification/badges/${userId}/progress`);
    if (response.status !== 200) {
      throw new Error('Failed to fetch badge progress');
    }
    return response.data;
  },

  fetchLeaderboard: async (limit = 10) => {
    const response = await apiClient.get(`/gamification/leaderboard`, {params: { limit: limit ?? 10 },});
    if (response.status !== 200) {
      throw new Error('Failed to fetch leaderboard');
    }
    return response.data;
  },

  deleteBadge: async (badgeId) => {
    const response = await apiClient.delete(`/gamification/badges/${badgeId}`);
    if (response.status !== 200) {
      throw new Error('Failed to delete badge');
    }
    return response.data;
  }
};

export default GamificationAPI;